import { Injectable, isDevMode } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoggerService {
  log(message: string, ...optionalParams: any[]): void {
    if (isDevMode()) {
      console.log(message, ...optionalParams);
    }
  }

  error(message: string, ...optionalParams: any[]): void {
    console.error(message, ...optionalParams);
    // here we put the logic to send error to an outside service
  }
}
